import { Stack, Typography } from "@mui/material";
import React from "react";
import { salesData } from "./data";
import { styled } from "@mui/material/styles";
import { numberFormat, shouldHideSpend } from "../../../utils/utils";

const Item = styled("div")(({ theme }) => ({
  color: theme.palette.common.white,
  marginTop: 16,
  marginBottom: 16,
  width: "24.5%",
  [theme.breakpoints.down("lg")]: {
    width: "20.5%",
  },
  [theme.breakpoints.down("md")]: {
    width: "33.3%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "50%",
  },
  padding: theme.spacing(0, 2),
}));

const renderSalesData = (reportingTiles, authUserData) => {
  return (
    <Stack
      direction={"row"}
      flexWrap={"wrap"}
      sx={{ p: (theme) => theme.spacing(0, 1, 2) }}
    >
      {/* {
                salesData.map((item, key) => ( */}
      {!shouldHideSpend(authUserData) &&
        (authUserData.is_sys_admin == 1 ||
          authUserData?.user_permissions?.includes("show_gross") == true) && (
        <Item>
          <Typography variant={"body1"} color={"common.white"} mb={1}>
            $
            {reportingTiles && reportingTiles.spend
              ? numberFormat(reportingTiles.spend)
              : "0"}
          </Typography>
          <Typography variant={"h6"} color={"common.white"} mb={0}>
            Spend
          </Typography>
        </Item>
      )}

      {(authUserData.is_sys_admin == 1 ||
        authUserData?.user_permissions?.includes("show_net") == true) && (
        <Item>
          <Typography variant={"body1"} color={"common.white"} mb={1}>
            $
            {reportingTiles && reportingTiles.net
              ? numberFormat(reportingTiles.net)
              : "0"}
          </Typography>
          <Typography variant={"h6"} color={"common.white"} mb={0}>
            Net
          </Typography>
        </Item>
      )}

      {(authUserData.is_sys_admin == 1 ||
        authUserData?.user_permissions?.includes("show_profit") == true) && (
        <Item>
          {/* CTR formula => $summary['ctr'] = ($r->impressions == 0) ? 0 : round(($r->clicks / $r->impressions) * 100, 2); */}
          {/* $report['profit']=round(($report['spend'] - ($report['net'] + $report['margin']  + $report['datacost'])), 2); */}
          <Typography variant={"body1"} color={"common.white"} mb={1}>
            $
            {reportingTiles &&
            reportingTiles.net >= 0 &&
            reportingTiles.spend >= 0 &&
            reportingTiles.datacost >= 0
              ? numberFormat(
                  reportingTiles.spend -
                    (reportingTiles.net +
                      reportingTiles.margin +
                      reportingTiles.datacost),
                )
              : "0"}
          </Typography>
          <Typography variant={"h6"} color={"common.white"} mb={0}>
            Profit
          </Typography>
        </Item>
      )}

      <Item>
        <Typography variant={"body1"} color={"common.white"} mb={1}>
          {reportingTiles &&
          reportingTiles.impressions != 0 &&
          reportingTiles.clicks >= 0
            ? (
                (reportingTiles.clicks / reportingTiles.impressions) *
                100
              ).toFixed(2)
            : "0"}
          %
        </Typography>
        <Typography variant={"h6"} color={"common.white"} mb={0}>
          CTR
        </Typography>
      </Item>
      {/* ))
            } */}
    </Stack>
  );
};
export default renderSalesData;
